import { colorsToLoja, colorsMakeACoffee } from '../styles/colors';

type OrganizationType = {
  [key: string]: {
    name: string,
		description: string,
		imgName: string,
		imgUri: any,
		colors: any,
		favicon: string,
  }
}
const organizations: OrganizationType = {
	"toloja": {
		name: 'ToLoja',
		description: 'Sua Loja Online',
		imgName: 'ToLoja',
		imgUri: require('../assets/images/logoToLoja.png'),
		colors: colorsToLoja,
		favicon: '%PUBLIC_URL%/faviconToLoja.ico',
	},
};
export { organizations };
